import { format } from 'date-fns';

// UTILITY
import bugsnag from '@/utility/bugsnagClient';

export const getTimezone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

export function getCurrentUtcDate() {
  const now = new Date();

  return `${now.toISOString().split('.')[0]}Z`;
}

export function getUtcDate(date) {
  const dateInst = new Date(date);

  return new Date(dateInst.getTime() + dateInst.getTimezoneOffset() * 60000);
}

export function convertToDate(date) {
  if (date instanceof Date) return date;

  try {
    return getUtcDate(date);
  } catch (e) {
    // eslint-disable-next-line
    console.warn(e);

    return new Date(date.replace(/-/g, '/'));
  }
}

export function formatDate(date, formatStr) {
  if (!date) return '';

  try {
    const dateObj = convertToDate(date);

    return format(dateObj, formatStr);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);

    bugsnag.notify(new Error('FormatDate error', { cause: e }));
    return '';
  }
}

export default getTimezone;
